var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-next-wrapper"},[_c('button',{attrs:{"id":"next-button"},on:{"click":_vm.goToWork}},[_c('span',{staticClass:"button-text"},[_vm._v("\n            Work\n        ")]),_vm._v(" "),_c('span',{staticClass:"line"})])])}
var staticRenderFns = []

export { render, staticRenderFns }